import React from "react";
import { PageContainer } from "components/shared";
import RequestList from "./requestlist";

const RestockRequests = () => {
  return (
    <PageContainer
      title="Restock Requests"
      subtitle="Products at or below their low-stock threshold"
    >
      <RequestList />
    </PageContainer>
  );
};

export default RestockRequests;
